import React from 'react'
import { Provider } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import Router from '@/modern/components/Router'
import { TokenProvider } from '@/store/context/token-provider/token-provider'
import WebComponentsBuilder from '@webmotors/media-lib-ui/web-components'
import { CookieNoticeProvider } from '../store/context/cookie-notice-context'
import configureStore from './store'
import theme from '../styles/theme'
import Perimeterex from './perimeterex'

const initialState = window.INITIAL_STATE
const store = configureStore(initialState)

WebComponentsBuilder.load(['zone-slot'])

export default () => {
  return (
    <CookieNoticeProvider>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <TokenProvider>
            <Router />
            <Perimeterex />
          </TokenProvider>
        </Provider>
      </ThemeProvider>
    </CookieNoticeProvider>
  )
}
